import { createGlobalStyle } from "styled-components";

export const GlobalOverlaysStyled = createGlobalStyle`
    .popover {
        background-color: unset;
        border: none;
        max-width: none;
    }

    .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .bs-popover-top > .popover-arrow::after {
        border-top-color: var(--color-purple-highlight);
        bottom: 2px;
    }

    .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .bs-popover-bottom > .popover-arrow::after {
        border-bottom-color: var(--color-purple-highlight);
        top: 2px;
    }

    .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .bs-popover-start > .popover-arrow::after {
        border-left-color: var(--color-purple-highlight);
    }

    .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .bs-popover-end > .popover-arrow::after {
        border-right-color: var(--color-purple-highlight);
    }

    .offcanvas.show {
        //z-index: 9999;
    }

    .offcanvas {
        background-color: var(--color-background-primary);
        overflow-y: auto;

        &.offcanvas-end {
            border-left: none;
        }

        .dropdown-menu {
            width: 100%;
            top: 3rem;
        }
    }

    .offcanvas-end {
        padding: 0;
    }

    .offcanvas-bottom {
        background-color: var(--color-background-secondary);
        height: unset;
        border-radius: 16px 16px 0px 0px;
        padding: 16px;
        box-shadow: var(--shadow-bottom-sheet);
        border-top: none;
        
        // Bottom sheet - модалка, вылезающая снизу, без отступов от края и снизу (default)
        // Action sheet - модалка с отступом от краёв и снизу

        &.action-sheet {
            margin: 16px;
            border-radius: 16px;
            width: calc(100% - 32px) !important;
            box-shadow: var(--shadow-primary);
        }
    }

    .offcanvas-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
        padding: 0 16px;
    }
    
    .offcanvas + .offcanvas-backdrop {
        z-index: 1050;
    }

    .offcanvas + .offcanvas-backdrop + .offcanvas {
        z-index: 1060;
    }

    .offcanvas-grabber {
        display: flex;
        justify-content: center;
        margin-top: -16px;
        padding-bottom: 8px;
    }

    .desktop-popup {
        z-index: 1160;

        .modal-dialog {
            .modal-content {
                border: none;
            }

            .modal-header {
                padding: 24px;
            }

            .modal-body {
                padding: 0 18px 24px 24px;
                overflow-y: auto;
                max-height: calc(100vh - 228px);
                margin-right: 6px;
            }

            &.modal-xl {
                max-width: 900px;
            }

            &.modal-lg {
                max-width: 700px;
            }

            max-width: 600px;

            &.modal-sm {
                max-width: 400px;
                
                .modal-header {
                    padding: 16px;
                }

                .modal-body {
                    padding: 0 10px 16px 16px;
                }
            }
        }
    }

    .desktop-popup-backdrop {
        z-index: 1150;
    }
`;
